import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

// Styled Paper container for DeskCalculatorPanel
export const StyledCalculatorPanel = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  background: 'linear-gradient(145deg, rgba(12,18,32,0.9), rgba(34,211,238,0.06))',
  border: `1px solid ${theme.palette.primary.main}33`,
  boxShadow: theme.shadows[14],
  [theme.breakpoints.up('lg')]: { maxHeight: 650 },
  [theme.breakpoints.up('xl')]: { maxHeight: 'none' },
}));
